export default "__VITE_ASSET__CUYzopHm__"